import { InventoryType, PREORDER_INVENTORY } from '@src/quince-site-common/src/domains/ProductPurchaseInfo'
import { isInNewCartExperiment } from '@src/quince-site-common/src/hooks/cart/hooks/new-cart-exp-helper'
import { ShopifyVariantMetaField } from '@src/quince-site-common/src/hooks/shopify/queryVariantsByProductId'
import { getInventoryType } from '@src/quince-site-common/src/hooks/shopify/shopify-utils'

interface InventoryDataType {
  inventoryType: InventoryType
}

function getPreorder(
  shopifyVariantMetaFieldOrIsPreOrder?: InventoryDataType | ShopifyVariantMetaField | boolean,
  isNewPreorderItem?: boolean,
) {
  let isPreorder = false
  const isNewCart = isInNewCartExperiment()

  if (isNewCart) {
    if (typeof shopifyVariantMetaFieldOrIsPreOrder === 'boolean') {
      isPreorder = shopifyVariantMetaFieldOrIsPreOrder
    } else {
      isPreorder = (shopifyVariantMetaFieldOrIsPreOrder as InventoryDataType)?.inventoryType === PREORDER_INVENTORY
    }
  } else if (typeof shopifyVariantMetaFieldOrIsPreOrder === 'boolean') {
    isPreorder = shopifyVariantMetaFieldOrIsPreOrder
  } else if (shopifyVariantMetaFieldOrIsPreOrder) {
    isPreorder = getInventoryType(shopifyVariantMetaFieldOrIsPreOrder as ShopifyVariantMetaField) === PREORDER_INVENTORY
  }

  return { showPreorder: isPreorder }
}

export default getPreorder
